/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import MenuItem from "@mui/material/MenuItem";
import { Box } from "@mui/material";
import { Loading } from "notiflix/build/notiflix-loading-aio";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import { Confirm } from "notiflix/build/notiflix-confirm-aio";
import moment from "moment";
import { CustomSelect } from "components/CustomSelect";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import DateTime from "components/DateTime";
import QuoteDetails from "views/Quotes/QuoteDetails";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { useLazyGetAllQuotesByCountryQuery, useCancelQuoteMutation } from "services/quotes";
import { globalCountry } from "store/entities/countries";
import MDBadge from "components/MDBadge";
import { dateFormat, tables } from "utils/constants";
import Alert from "components/CustomAlert";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { useGetAllBDMWithInactiveQuery } from "services/bdm";
import { notificationForwardSection, resetForwardSection } from "store/entities/notifications";
import { Edit } from "@mui/icons-material";
import EditQuote from "./EditQuote";

function Quotes() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [modifiedBDMArray, setModifiedBDMArray] = useState([]);
  const [selectedBDM, setSelectedBDM] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [orderTotal, setOrderTotal] = useState(0);
  const dispatch = useDispatch();
  const navigate = useHistory();
  const selectedCountry = useSelector(globalCountry);
  const [triggerQuotes, { data: quotesList = [], isSuccess }] = useLazyGetAllQuotesByCountryQuery();

  const { data: BDMList } = useGetAllBDMWithInactiveQuery();
  const [cancelQuoteMutation] = useCancelQuoteMutation();
  const notificationDetails = useSelector(notificationForwardSection);
  const [openEditQuoteDialog, setOpenEditQuoteDialog] = useState(false);
  const [selectedQuote, setSelectedQuote] = useState(null);

  useEffect(() => {
    triggerQuotes(selectedCountry.id);
  }, [selectedCountry]);

  useEffect(() => {
    Loading.dots({
      svgColor: "rgba(159, 3, 3, 0.8)",
    });

    isSuccess && Loading.remove(500);
  }, [isSuccess]);

  useEffect(() => {
    setTableData([]);
    setSelectedBDM(0);
  }, [selectedCountry]);

  useEffect(() => {
    const currentDate = new Date();
    setEndDate(currentDate);

    // Calculate one month before the current date
    const oneMonthBefore = new Date(currentDate);
    oneMonthBefore.setMonth(currentDate.getMonth() - 1);

    // Set startDate to one month before the current date
    setStartDate(oneMonthBefore);
  }, [selectedCountry]);

  useEffect(() => {
    if (BDMList && BDMList.length > 0) {
      let combinedArray = [...BDMList];
      combinedArray.push({
        id: 0,
        email: "All",
        first_name: "All",
        last_name: "",
        active: 1,
        created_date: "",
        assigned_date: "",
        total_sales: 0,
      });
      setModifiedBDMArray(combinedArray.sort((a, b) => a.id - b.id));
    }
  }, [BDMList]);

  useEffect(() => {
    if (quotesList) {
      if (Object.keys(notificationDetails).length > 0) {
        setSelectedBDM(0);
        setStartDate(null);
        setEndDate(null);
        if (notificationDetails.category == "QUOTES") {
          let allQuotes = [...quotesList];
          let arrayIndex = allQuotes.findIndex((item) => item.id == notificationDetails.id);
          if (arrayIndex > -1) {
            const [element] = allQuotes.splice(arrayIndex, 1);
            allQuotes.unshift(element);

            setTableData(allQuotes);

            setTimeout(() => {
              const element = document.getElementById(`orderId${notificationDetails.id}`);
              if (element) {
                element.click();
              }
            }, 200);
          } else {
            const filteredData = quotesList.filter((quote) => {
              var res = selectedBDM != 0 ? quote.bdm_id == selectedBDM : true;
              return res;
            });
            setTableData(filteredData);

            Notify.failure("Order not found!");
          }
        }
      } else {
        const filteredData = quotesList.filter((quote) => {
          var res = selectedBDM != 0 ? quote.bdm_id == selectedBDM : true;
          return res;
        });
        setTableData(filteredData);
      }
    }
  }, [quotesList, startDate, endDate, selectedBDM, notificationDetails]);

  useEffect(() => {
    if (tableData.length > 0 && notificationDetails.id) {
      if (tableData[0].id != notificationDetails.id) {
        let allQuotes = [...tableData];
        let arrayIndex = tableData.findIndex((item) => item.id == notificationDetails.id);
        if (arrayIndex > -1) {
          const [element] = allQuotes.splice(arrayIndex, 1);
          allQuotes.unshift(element);

          setTableData(allQuotes);
        }
      }
      setTimeout(() => {
        const element = document.getElementById(`orderId${notificationDetails.id}`);
        if (element) {
          element.click();
        }
      }, 1000);
    }
  }, [tableData, notificationDetails]);

  useEffect(() => {
    if (selectedBDM != 0) {
      let filteredTotal = 0;
      let total = 0;

      if (tableData && tableData.length > 0) {
        for (let single of tableData) {
          filteredTotal = filteredTotal + single.grandtotal;
          total = total + single.grandtotal;
          if (single.refunded_amount) {
            filteredTotal = filteredTotal - single.refunded_amount;
          }
        }
      }

      setTotalSales(filteredTotal.toFixed(2));
      setOrderTotal(total.toFixed(2));
    }
  }, [tableData, selectedBDM]);

  useEffect(() => {
    return () => {
      dispatch(resetForwardSection());
    };
  }, []);

  const cancelQuote = async (id) => {
    try {
      Loading.dots({
        svgColor: "rgba(159, 3, 3, 0.8)",
      });
      cancelQuoteMutation({
        quoteId: id,
        countryId: selectedCountry.id,
      }).then((cancelResponse) => {
        if (cancelResponse.data?.status == "success") {
          Notify.info("Quote has been successfully canceled!");
        }
      });
    } catch (e) {
    } finally {
      Loading.remove(500);
    }
  };

  return (
    <Card>
      <CardHeader
        title={<MDTypography color="info">Quotes</MDTypography>}
        action={
          <MDButton
            variant="gradient"
            color="info"
            onClick={() => navigate.push(`/user/add-quote`)}
          >
            Add Quote
          </MDButton>
        }
      />
      <CardContent>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={3} lg={3} xl={3}>
            <DateTime
              label="Start date *"
              name="start_date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e);
                dispatch(resetForwardSection());
              }}
              inputProps={{
                placeholder: "Pick a Start Date",
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3} lg={3} xl={3}>
            <DateTime
              label="End date *"
              name="end_date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e);
                dispatch(resetForwardSection());
              }}
              inputProps={{
                placeholder: "Pick a End Date",
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3} lg={3} xl={3}>
            <CustomSelect
              label="Filter by BDM *"
              inputProps={{
                id: "bdm_id",
                name: "bdm_id",
              }}
              value={selectedBDM}
              onChange={(e) => {
                setSelectedBDM(e.target.value);
                dispatch(resetForwardSection());
              }}
              sx={{
                textTransform: "capitalize",
                "& .MuiInputBase-root .MuiSelect-select": {
                  height: "44px",
                  // color: "#fff",
                  // fontWeight: "400",
                },
                "& .MuiFormLabel-root": {
                  backgroundColor: "#fff",
                  // color: "#e0e1e5",
                  padding: "0 5px",
                },
              }}
              // helperText={errors.country_id}
              // error={errors.country_id}
            >
              <MenuItem disabled>BDMs</MenuItem>
              {modifiedBDMArray.map((prop, key) => (
                <MenuItem sx={{ textTransform: "capitalize" }} key={key} value={prop.id}>
                  {prop.first_name + " " + prop.last_name}
                </MenuItem>
              ))}
            </CustomSelect>
          </GridItem>
          <GridItem xs={12} sm={12} md={3} lg={3} xl={3}></GridItem>
          <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
            <GridContainer sx={{ mb: 2 }}>
              <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                {modifiedBDMArray && modifiedBDMArray.length > 0 && selectedBDM != 0 && (
                  <Card sx={{ height: "100%" }}>
                    <MDBox
                      pt={2}
                      px={2}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <MDTypography variant="h6" fontWeight="medium">
                        {modifiedBDMArray.filter((item) => item.id == selectedBDM)[0].first_name +
                          " " +
                          modifiedBDMArray.filter((item) => item.id == selectedBDM)[0]
                            .last_name}{" "}
                        {!modifiedBDMArray.filter((item) => item.id == selectedBDM)[0].active && (
                          <MDBadge
                            badgeContent="Inactive"
                            color="error"
                            variant="gradient"
                            size="sm"
                          />
                        )}
                      </MDTypography>
                    </MDBox>
                    <MDBox p={2}>
                      <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                        <MDBox
                          component="li"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          py={1}
                          pr={1}
                        >
                          <MDBox lineHeight={1.125}>
                            <MDTypography display="block" variant="button" fontWeight="medium">
                              From {moment(startDate).format(dateFormat)} to{" "}
                              {moment(endDate).format(dateFormat)}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                        <MDBox
                          component="li"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          pr={1}
                        >
                          <MDBox lineHeight={1.125}>
                            <MDTypography variant="caption" fontWeight="regular" color="text">
                              Total
                            </MDTypography>
                          </MDBox>
                          <MDBox display="flex" alignItems="center">
                            <MDTypography variant="caption" fontWeight="regular" color="text">
                              {selectedCountry.currency} {orderTotal}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                        <MDBox
                          component="li"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          py={1}
                          pr={1}
                          mb={1}
                        >
                          <MDBox lineHeight={1.125}>
                            <MDTypography variant="caption" fontWeight="regular" color="text">
                              Total sales
                            </MDTypography>
                          </MDBox>
                          <MDBox display="flex" alignItems="center">
                            <MDTypography
                              variant="button"
                              fontWeight="regular"
                              sx={{ fontSize: "1.25rem", color: "#494b53", fontWeight: 500 }}
                            >
                              {selectedCountry.currency} {totalSales}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                )}
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
        {tableData && tableData.length > 0 ? (
          <DataTable
            id={tables.QUOTES}
            headerActions={
              <Tooltip title="Refetch quotes" sx={{ ml: 1 }} placement="top">
                <IconButton
                  aria-label="view"
                  size="small"
                  onClick={() => triggerQuotes(selectedCountry.id)}
                >
                  <RestartAltIcon color="info" fontSize="inherit" />
                </IconButton>
              </Tooltip>
            }
            columns={[
              {
                Header: "SO Number",
                accessor: "so_number",
              },
              {
                Header: "Has Custom Products",
                accessor: "has_custom_products",
                Cell: ({ row: { original } }) => (
                  <MDBox>
                    {original.has_custom_products ? (
                      <MDBadge badgeContent="Yes" color="success" variant="gradient" size="sm" />
                    ) : (
                      <MDBadge badgeContent="No" color="error" variant="gradient" size="sm" />
                    )}
                  </MDBox>
                ),
              },
              {
                Header: "Contact Name",
                accessor: "contact_name",
                Cell: ({ row: { original } }) =>
                  original.reseller?.companies?.name ? (
                    <MDBox>
                      <MDBox>{original.contact_name}</MDBox>
                      <MDBox sx={{ fontWeight: 600, fontSize: "11px" }}>
                        {original.reseller?.companies?.name}
                      </MDBox>
                    </MDBox>
                  ) : (
                    <>
                      <>{original.contact_name}</>
                    </>
                  ),
              },
              {
                Header: "Date",
                accessor: "datetime",
                Cell: ({ row: { original } }) => moment(original.datetime).format(dateFormat),
              },
              {
                Header: "Total",
                accessor: "grandtotal",
                Cell: ({ row: { original } }) => (
                  <>
                    {selectedCountry.currency} {original.grandtotal?.toFixed(2)}
                  </>
                ),
              },

              {
                Header: "Status",
                accessor: "quote_status",
                Cell: ({ row: { original } }) => (
                  <MDBox>
                    <MDBadge
                      badgeContent={original.quote_status}
                      color={
                        original.quote_status === "CONVERTED"
                          ? "success"
                          : original.quote_status === "SENT"
                          ? "warning"
                          : "error"
                      }
                      variant="gradient"
                      size="sm"
                    />
                  </MDBox>
                ),
              },
              {
                Header: "Actions",
                accessor: "actions",
                disableSortBy: true,
                disableFilters: true,
                show: true,
                align: "right",
                // eslint-disable-next-line react/display-name
                Cell: ({ row: { original } }) => (
                  <div className="actions-right">
                    {original.id == notificationDetails.id && (
                      <div
                        className="highlight-animation"
                        style={{
                          position: "absolute",
                          borderRadius: 5,
                          top: 0,
                          right: 0,
                          left: 0,
                          bottom: 0,
                        }}
                      ></div>
                    )}
                    <QuoteDetails id={original.id} order={original} />
                    {original.quote_status != "CONVERTED" && (
                      <>
                        <Tooltip title="Edit Quote" placement="top">
                          <IconButton
                            aria-label="edit"
                            size="small"
                            onClick={() => {
                              setOpenEditQuoteDialog(true);
                              setSelectedQuote(original);
                            }}
                          >
                            <Edit fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancel Quote" placement="top">
                          <IconButton
                            aria-label="view"
                            size="small"
                            onClick={() =>
                              Confirm.show(
                                `Please Confirm`,
                                "Are you sure you want to cancel this quote?",
                                "Yes",
                                "No",
                                () => {
                                  cancelQuote(original.id);
                                },
                                () => {},
                                {}
                              )
                            }
                          >
                            <CancelIcon color="error" fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </div>
                ),
              },
            ]}
            data={tableData || []}
            isSorted={true}
            entriesPerPage={false}
            showTotalEntries={false}
            hideColumnSelection={false}
            noEndBorder
            canSearch
            stateReducer={(newState, action) => {
              // console.log(newState);
              // console.log(action);
              if (action.type === "toggleRowSelected") {
                newState.selectedRowIds = {
                  [action.id]: action.value,
                };
              }
              return newState;
            }}
          />
        ) : (
          <Alert severity="warning">No Quotes found!</Alert>
        )}
      </CardContent>
      {selectedQuote && (
        <EditQuote
          open={openEditQuoteDialog}
          onClose={() => {
            setOpenEditQuoteDialog(false);
            setSelectedQuote(null);
          }}
          initialFormState={selectedQuote}
        />
      )}
    </Card>
  );
}

export default Quotes;
